import { User } from '../../interfaces/user-interfaces';
import { Permission } from '../../enums/permissions.enum';

export interface ErrorLog {
  action: string; // e.g., "LOGIN_FAILURE", "PERMISSIONS_FAILURE"
  message: string; // The actual error message
  timestamp: number; // Time of occurrence
}

export interface AuthState {
  token: string | null; // JWT token as a string or null if unauthenticated
  user: User | null; // User details, or null if unauthenticated
  roles: Permission[] | null; // User roles

  errorLogs: ErrorLog[];
}

export const initialAuthState: AuthState = {
  token: null,
  user: null,
  roles: null,
  errorLogs: [],
};
